import axios from "axios";
import printJS from "print-js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Print PDF lewat print-js (hidden iframe + native print dialog).
// JANGAN pakai window.print() sebagai fallback: browser akan mencetak halaman web, bukan PDF-nya.
export const printPdf = async (path) => {
  const res = await api.get(path, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const openInTab = () => {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.target = "_blank";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  try {
    printJS({
      printable: blobUrl,
      type: "pdf",
      onError: openInTab,
    });
  } catch {
    openInTab();
  }
  setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
};

export const fmtIDR = (n) => {
  const v = Number(n || 0);
  if (!isFinite(v)) return "Rp 0";
  return "Rp " + Math.round(v).toLocaleString("id-ID");
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

// Palette-aligned colors for pipeline stages (Dusty Coral / Muted Yellow / Muted Periwinkle)
export const RATE_META = {
  1: { label: "Hot",  letter: "H", bg: "bg-[#FFD7B5]", text: "text-[#FF6B7D]", border: "border-[#FFD7B5]", dot: "bg-[#FF6B7D]", pill: "bg-[#FF6B7D]", soft: "bg-[#FFD7B5] text-[#FF6B7D]" },
  2: { label: "Warm", letter: "W", bg: "bg-[#FFE89A]", text: "text-[#7A6633]", border: "border-[#FFE89A]", dot: "bg-[#FFDB52]", pill: "bg-[#FFDB52]", soft: "bg-[#FFE89A] text-[#7A6633]" },
  3: { label: "Cold", letter: "C", bg: "bg-[#DCE0E7]", text: "text-[#4E6D9A]", border: "border-[#DCE0E7]", dot: "bg-[#97ADD4]", pill: "bg-[#97ADD4]", soft: "bg-[#DCE0E7] text-[#4E6D9A]" },
};

// Terminal status (overrides Rate visually when set) — palette aligned
export const STATUS_META = {
  active: { label: "Aktif", pill: "",                  dot: "bg-[#A0A3A8]", chip: "" },
  won:    { label: "Deal",  pill: "bg-[#57D28A]",     dot: "bg-[#57D28A]", chip: "bg-[#C9F0D6] text-[#4A6D53] border-[#C9F0D6]" },
  lost:   { label: "Lost",  pill: "bg-[#A0A3A8]",     dot: "bg-[#A0A3A8]", chip: "bg-[#DCE0E7] text-[#626061] border-[#DCE0E7]" },
};

export const PRIMARY = "#090808";
export const PRIMARY_HOVER = "#000000";
